/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deft_Vivid_Pigeon_MendInputs */

const en_deft_vivid_pigeon_mend = /** @type {(inputs: Deft_Vivid_Pigeon_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

const de_deft_vivid_pigeon_mend = /** @type {(inputs: Deft_Vivid_Pigeon_MendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Details`)
};

/**
* | output |
* | --- |
* | "Details" |
*
* @param {Deft_Vivid_Pigeon_MendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const deft_vivid_pigeon_mend = /** @type {((inputs?: Deft_Vivid_Pigeon_MendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deft_Vivid_Pigeon_MendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deft_vivid_pigeon_mend(inputs)
	return de_deft_vivid_pigeon_mend(inputs)
});